var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"formTarget",staticClass:"hs-form-frame",attrs:{"id":_vm.formTargetId}})
}
var staticRenderFns = []

export { render, staticRenderFns }